export const acid_impact_time = [
  "7",
  "11",
  "15",
  "18",
  "27",
  "38",
  "45",
  "60",
  "75",
  "100",
  "125",
  "160",
  "210",
  "270",
];

export const impact_time = [
  "4",
  "7",
  "9",
  "13",
  "15",
  "20",
  "27",
  "35",
  "40",
  "47",
  "55",
  "75",
  "105",
  "150",
];

export const acid_pump_time = [
  "0.5",
  "1",
  "2",
  "4",
  "9",
  "18",
  "27",
  "36",
  "45",
  "54",
  "72",
  "90",
  "135",
  "180",
];

export const pump_time = [
  "0.2",
  "0.5",
  "0.9",
  "1",
  "1",
  "3",
  "4",
  "5",
  "7",
  "8",
  "11",
  "14",
  "20",
  "27",
];

export const pool_size = [
  "0.1",
  "0.5",
  "1",
  "2",
  "5",
  "10",
  "15",
  "20",
  "25",
  "30",
  "40",
  "50",
  "75",
  "100",
];
